import React, { useState } from 'react';

import { useGetReportingLensFields } from '~/hooks/apis/reporting/useLensAuthoring';

import PickPopover from './PickPopover';

type AddFilterProps = {
  lensId: string;
  lensVersion: number;
  taken: Set<string>;
  onAdd: (column: string, numeric: boolean) => void;
};

const LINK = {
  color: 'text.secondary',
  fontSize: 12,
  fontWeight: 500,
  minHeight: 24,
  px: 0.5,
  textDecoration: 'underline dotted',
  textUnderlineOffset: '3px',
  '&:hover': { color: 'primary.main' },
};

export default function AddFilter({ lensId, lensVersion, taken, onAdd }: AddFilterProps) {
  const [wanted, setWanted] = useState(false);
  const fields = useGetReportingLensFields(lensId, lensVersion, wanted);
  const columns = [
    ...new Map(
      (fields.data?.datasets ?? []).flatMap((dataset) =>
        dataset.columns
          .filter((column) => column.kind !== 'date' && !taken.has(column.name))
          .map((column) => [column.name, column] as const),
      ),
    ).values(),
  ];

  return (
    <span className="add-filter">
      <PickPopover
        clearable={false}
        empty={fields.isLoading ? 'Reading the fields…' : 'No other fields'}
        label="Filter by another field"
        onOpen={() => setWanted(true)}
        onPick={([name]) => name && onAdd(name, columns.find((column) => column.name === name)?.kind === 'measure')}
        options={columns.map((column) => ({ value: column.name, label: column.label }))}
        picked={[]}
        single
        triggerSx={LINK}
      >
        + Filter
      </PickPopover>
    </span>
  );
}
